import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Footer.css';
import LegalModal from './LegalModal';
import {
  EmailIcon,
} from './Icons';

const SUPPORT_EMAIL = 'hrv4hrv4@gmail.com';

function Footer() {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  const [legalModalType, setLegalModalType] = useState(null);

  const handleNav = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  return (
    <footer className="site-footer">
      <div className="footer-content">

        {/* Brand Column */}
        <div className="footer-column brand-column">
          <div className="footer-logo">
            <span className="brand-name">HRV-4</span>
          </div>
          <p className="footer-desc">
            Track, analyze, and understand your Heart Rate Variability with AI-powered insights.
          </p>
        </div>

        {/* Support Column */}
        <div className="footer-column support-column">
          <h4 className="column-title">Support</h4>
          <ul className="footer-links">
            <li onClick={() => handleNav('/faq')}>FAQ &amp; Help Center</li>
            <li onClick={() => handleNav('/sensors')}>Sensor Setup</li>
            <li onClick={() => handleNav('/profile')}>Account</li>
          </ul>
        </div>

        {/* Legal Column */}
        <div className="footer-column legal-column">
          <h4 className="column-title">About</h4>
          <ul className="footer-links">
            <li onClick={() => setLegalModalType('terms')}>Terms of Service</li>
            <li onClick={() => setLegalModalType('privacy')}>Privacy Policy</li>
          </ul>
        </div>

        {/* Contact Column */}
        <div className="footer-column contact-column">
          <h4 className="column-title">Contact</h4>
          <div className="contact-info">
            <div className="contact-item">
              <EmailIcon size={16} color="#8e8e93" />
              <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
            </div>
          </div>
        </div>

      </div>

      <div className="footer-bottom">
        <p>&copy; {currentYear} HRV-4. All rights reserved.</p>
      </div>

      {legalModalType && (
        <LegalModal
          type={legalModalType}
          onClose={() => setLegalModalType(null)}
        />
      )}
    </footer>
  );
}

export default Footer;